<template>
	<div>
		<!-- <h4>Time Entries.</h4> -->


		<div>

			<vs-table stripe max-items="50" no-data-text="No Time Entries" pagination :data="timeEntryList" v-model="selectedTimeEntry" @selected="HandleSelectedTimeEntry">
				<template slot="header">
					<h3>
					Time Entries
					</h3>


					<div class="mb-2" >
						<vs-button type="relief" color="primary" @click="BeginCreatingNewEntry()" size="small" icon="add">Create New Entry</vs-button> 
						
					</div>
				</template>
				<template slot="thead">
					<vs-th>
					Time
					</vs-th>
					<vs-th v-if="isAdmin">
					Worker
					</vs-th>
					<vs-th class="min600">
					Client
					</vs-th>
					<vs-th class="min700">
					Category
					</vs-th>
					<vs-th >
					Project
					</vs-th>
					<vs-th >
					Task
					</vs-th>
					<vs-th class="min800">
					Description
					</vs-th>
					<!-- <vs-th class="min800">
					Actions
					</vs-th> -->
				</template>
				

				<template slot-scope="{data}">
					<vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

						<vs-td :data="data[indextr].startTime">
							<vs-chip class="min900">
								<vs-chip color="primary" class="my-1 mr-1"><h6 style="color:white">{{GetTimeDif(data[indextr].TimeIn, data[indextr].TimeOut)}}</h6> </vs-chip>
								<vs-chip color="primary" class="my-1 mr-1"> <h6 style="color:white">{{GetDateDay(data[indextr].TimeIn)}}</h6></vs-chip>
								<div class="ml-1" style="width: 115px;"> {{GetDateTimes(data[indextr].TimeIn, data[indextr].TimeOut)}}</div>
							</vs-chip>

							<div style="display: block; width: 70px;" v-if="windowWidth < 900" >
								<vs-chip color="primary" class="my-1 mr-1" style="width: 70px;">
									<h6 style="color:white">{{GetTimeDif(data[indextr].TimeIn, data[indextr].TimeOut)}}</h6> 
								</vs-chip>
								<vs-chip class="my-1 mr-1" style="width: 70px;"> 
									<h6 style="color:white">{{GetDateDay(data[indextr].TimeIn)}}</h6>
								</vs-chip>
							</div>
						</vs-td>

						<vs-td v-if="isAdmin" class="tableWorkerName">
							{{WorkerNameFromID(tr.WorkerID)}}
						</vs-td>

						<vs-td :data="data[indextr].client" class="min600">
							{{GetClientByID(data[indextr].ClientID).ClientName}}
						</vs-td>
						
				
						<vs-td :data="data[indextr].taskName" class="tableTaskName min700">
							{{GetCategoryByID(data[indextr].CategoryID).CategoryName}}
						</vs-td>

						<vs-td :data="data[indextr].category">
							<div class="tdInfo tableTaskName">
								{{GetProjectByID(data[indextr].TaskID).ProjectName}}
							</div>
						</vs-td>

						<vs-td :data="data[indextr].category">
							<div class="tdInfo tableTaskName">
								{{GetTaskByID(data[indextr].TaskID).Task}}
							</div>
						</vs-td>

						<vs-td :data="data[indextr].description" class="min800 tableNote">
							{{data[indextr].Note}}
						 </vs-td>
					

					</vs-tr>
					
				</template>
			</vs-table>
			

			<!-- <pre>{{ tableSelected }}</pre> -->
		</div>

	</div>
</template>


<script>

import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import 'vue-select/dist/vue-select.css'
const moment = require('moment') // require

// import DatetimePickerDatetime from './components/extra-components/datetime-picker/DatetimePickerDatetime.vue'


export default{
  components:{
    flatPickr,
    'v-select': vSelect
  },
  data () {
		
		
    return {
      selected		: null,
      selectedTimeEntry : null,
      promptActive	: false,
      editingEntry	: false,
      val:'',
      valMultipe:{
        value1:'',
        value2:''
      }
    }
  },
  computed:{
    isAdmin () {
      return this.$store.getters.GetIsAdmin
    },
    windowWidth () {
      return this.$store.state.windowWidth
    },
    timeEntryList () {
      return this.$store.getters.GetTimeEntryList
    },
    categoryList () {
      return this.$store.getters.GetCategoryList
    },
    clientList () {
      return this.$store.getters.GetClientList
    },
    taskList () {
      return this.$store.getters.GetTaskList
    },
    projectList () {
      return this.$store.getters.GetProjectList
    },
    workerList () {
      return this.$store.getters.GetWorkerList
    }
  },
  methods: {
    WorkerNameFromID (id) {
      if (this.workerList == null) return ''
      const worker = this.workerList.find(x => x.WorkerID == id)
      if (worker == null) return ''
      return worker.WorkerName
    },
    HandleSelectedTimeEntry (timeEntry) {
			
      this.$store.dispatch('ActionFetchTimeEntry', timeEntry.RecordID.toString()).then(response => {
        const data = response.data
        this.$store.dispatch('ActionSetTimeEntryPrompt', {
          active: true,
          title: 'Edit Existing Task Entry',
          recordID: data.RecordID,
          clientID: data.ClientID,
          categoryID: data.CategoryID,
          taskID: data.TaskID,
          startTime: moment(data.TimeIn, 'YYYY-MM-DD hh:mm A').format('hh:mm A'),
          startDate: moment(data.TimeIn, 'YYYY-MM-DD hh:mm A').format('Y-MM-DD'),
          endTime: moment(data.TimeOut, 'YYYY-MM-DD hh:mm A').format('hh:mm A'),
        			endDate: moment(data.TimeOut, 'YYYY-MM-DD hh:mm A').format('Y-MM-DD'),
          description: data.Note,
          action: 'edit', //create, edit, finish
          mileage: data.Mileage,
          sowID: data.SOWID,
          sowLineItemID: data.SOWLineItemID
        })

      })

    },
    GetClientByID (clientID) {
      let client = this.clientList.find(x => x.ClientID == clientID)
      if (client == null) client = {ClientName:'None'}

      return client
    },
    GetProjectByID (taskID) {
      const task = this.GetTaskByID(taskID)
      if (task.Task == 'None') {
        return {ProjectName:'None'}
      }
      let project = this.projectList.find(x => x.ProjectID == task.ProjectID)
      if (project == null) {
        project = {ProjectName:'None'}
      } else if (project.ProjectName == '' || project.ProjectName == null) {
        project = {ProjectName:'None'}
      }
			
      return project
    },
    GetTaskByID (taskID) {
      let task = this.taskList.find(x => x.TaskID == taskID)
      if (task == null) {
        task = {Task:'None'}
      } else if (task.Task == '' || task.Task == null) {
        task = {Task:'None'}
      }
			
      return task
    },
    GetCategoryByID (categoryID) {
      let category = this.categoryList.find(x => x.CategoryID == categoryID)
      if (category == null) category = {CategoryName : 'None'}

      return category
    },
    BeginCreatingNewEntry () {
      const currentTime = moment().format('hh:mm A')
      const currentDate = moment().format('Y-MM-DD')
      this.$store.dispatch('ActionSetTimeEntryPrompt', {
        active: true,
        title: 'Create New Time Entry',
        taskName: '',
        clientID: null,
        taskID: null,
        projectID: null,
        categoryID: null,
        startTime: currentTime,
        endTime: currentTime,
        startDate: currentDate,
        endDate: currentDate,
        description: '',
        error: 'Fields cannot be empty.',
        action: 'create', //create, edit, finish
        mileage: 0,
        sowID: null,
        sowLineItemID: null,
      })
    },
    GetDateDay (s) {
			
      return moment(s, 'YYYY-MM-DD hh:mm A').format('M/DD')
    },
    ParseToStandardDate (d) {
      if (d == null) return '2020-01-01 12:00:00'
      //AM
      if (d.indexOf('AM') != -1) {
        d = d.replace(' AM', ':00')
      } else { //PM
        d = d.replace(' PM', ':00')
        const s = d.split(' ')
        let t = s[1]
        let h = parseInt(t.substring(0, 2))
        if (h != 12) {
          h += 12
        }
        let hs = h
        if (h < 12) {
          hs = `0${  hs}`
        }
        t = hs + t.substring(2, t.length)
        d = `${s[0]  } ${  t}`
      }
      return d
    },
    GetDateTimes (s, e) {
      const format = 'YYYY-MM-DD hh:mm A'
      return `${moment(s, format).format('h:mm A')  } - ${  moment(e, format).format('h:mm A')}` 
    },
    GetTimeDif (s, e) {
      const format = 'YYYY-MM-DD hh:mm A'
      //return moment.utc(moment(e,format).diff(moment(s,format))).format("HH:mm")

      const ms = moment(e, format).diff(moment(s, format))
      const d = moment.duration(ms)
      const p = Math.floor(d.asHours()) + moment.utc(ms).format(':mm')

      return p


    }
		
  }
	
}


</script>

